import React from 'react';
import { FormControl, InputLabel, MenuItem, Select, Stack } from '@mui/material';
import { useCatalogPreferencesContext } from 'context/CatalogPreferencesContext';

const HeaderSelectors: React.FC = () => {
  const { locale, currency, setLocale, setCurrency } = useCatalogPreferencesContext();

  return (
    <Stack direction="row" spacing={1} flexWrap="wrap">
      <FormControl size="small" sx={{ minWidth: 100 }}>
        <InputLabel>Idioma</InputLabel>
        <Select label="Idioma" value={locale} onChange={(e) => setLocale(e.target.value)}>
          <MenuItem value="es-AR">ES</MenuItem>
          <MenuItem value="en">EN</MenuItem>
        </Select>
      </FormControl>
      <FormControl size="small" sx={{ minWidth: 100 }}>
        <InputLabel>Moneda</InputLabel>
        <Select label="Moneda" value={currency} onChange={(e) => setCurrency(e.target.value)}>
          <MenuItem value="ARS">ARS</MenuItem>
          <MenuItem value="USD">USD</MenuItem>
        </Select>
      </FormControl>
    </Stack>
  );
};

export default HeaderSelectors;
